import React from 'react'
import { components } from 'react-select'
import { Box, Checkbox, FormControlLabel, useTheme } from '@mui/material'
import { CheckIcon } from '../../Icons'
import { FilterCountChecked } from 'components/global/CUK/AsyncSelect/components/OptionStyles'

export const OptionSingle = ({
  isSelected,
  label,
  value,
  selectProps,
  isClickDisabledWhenSelected = false,
  ...props
}) => {
  const { displayedKey = false, onChange } = selectProps
  const theme = useTheme()

  const itemOption = (
    <label
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        opacity: isSelected ? 1 : 0.72,
        fontWeight: 500,
        fontSize: 12,
        lineHeight: 2,
        color: isSelected
          ? theme.palette.primary.main
          : theme.palette.grey[800],
        '&:hover': {
          color: 'white',
        },
      }}
    >
      {isSelected && (
        <Box
          display="flex"
          justifyContent="center"
          sx={{
            width: 14,
            height: 14,
            marginRight: theme.spacing(1),
          }}
        >
          <CheckIcon
            style={{
              color: theme.palette.primary.main,
              fontSize: 11,
              lineHeight: 1.143,
              '&:hover': {
                color: 'white',
              },
            }}
          />
        </Box>
      )}
      {label}
    </label>
  )

  const itemFieldOption = (
    <label
      style={{
        opacity: isSelected ? 1 : 0.47,
        fontWeight: 600,
        fontSize: 10,
        lineHeight: 2.4,
        color: isSelected
          ? theme.palette.primary.main
          : theme.palette.grey[800],
        marginLeft: theme.spacing(1),
      }}
    >
      {value}
    </label>
  )

  return (
    <Box
      onClick={() => {
        if (isSelected && !isClickDisabledWhenSelected) {
          onChange({})
        }
      }}
      sx={{
        backgroundColor: isSelected
          ? theme.palette.primary.lightest
          : theme.palette.common.white,
      }}
    >
      <components.Option {...props}>
        {itemOption}
        {displayedKey && itemFieldOption}
      </components.Option>
    </Box>
  )
}

export const OptionMulti = ({
  isSelected,
  label,
  value,
  selectProps,
  ...props
}) => {
  const {
    displayedKey = false,
    showSelected,
    onChange,
    value: values,
    keyField,
  } = selectProps
  const theme = useTheme()

  const itemOption = (
    <FormControlLabel
      control={
        <Checkbox
          checked={isSelected}
          onClick={() => {
            if (isSelected) {
              onChange(values.filter((e) => e[keyField] !== value))
            }
          }}
          sx={{
            '& > input': {
              height: '200%',
              top: '-50%',
            },
          }}
        />
      }
      label={
        <label
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            opacity: isSelected ? 1 : 0.72,
            fontWeight: 500,
            fontSize: 12,
            lineHeight: 2,
            color: isSelected
              ? theme.palette.primary.main
              : theme.palette.grey[800],
            paddingLeft: 8,
          }}
        >
          {label}
        </label>
      }
    />
  )

  const itemFieldOption = (
    <label
      style={{
        opacity: isSelected ? 1 : 0.47,
        fontWeight: 600,
        fontSize: 10,
        lineHeight: 2.4,
        color: isSelected
          ? theme.palette.primary.main
          : theme.palette.grey[800],
        marginLeft: theme.spacing(1),
      }}
    >
      {value}
    </label>
  )

  return (
    <Box
      hidden={showSelected && !isSelected}
      sx={{
        backgroundColor: isSelected
          ? theme.palette.primary.lightest
          : theme.palette.common.white,
      }}
    >
      <components.Option {...props}>
        {itemOption}
        {displayedKey && itemFieldOption}
      </components.Option>
    </Box>
  )
}

export const OptionMultiCount = ({
  isSelected,
  label,
  value,
  selectProps,
  count = -1,
  ...props
}) => {
  const {
    displayedKey = false,
    showSelected,
    onChange,
    value: values,
    keyField,
  } = selectProps
  const theme = useTheme()

  const itemOption = (
    <FormControlLabel
      control={
        <Box
          onClick={() => {
            if (isSelected) {
              onChange(values.filter((e) => e[keyField] !== value))
            }
          }}
        />
      }
      label={
        <label
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            cursor: 'pointer',
            opacity: isSelected ? 1 : 0.72,
            fontWeight: 500,
            fontSize: 12,
            lineHeight: 2,
            color: isSelected
              ? theme.palette.grey[700]
              : theme.palette.grey[600],
            paddingLeft: 8,
          }}
        >
          {label}
        </label>
      }
    />
  )

  const itemFieldOption = (
    <label
      style={{
        opacity: isSelected ? 1 : 0.47,
        fontWeight: 600,
        fontSize: 10,
        lineHeight: 2.4,
        color: isSelected
          ? theme.palette.primary.main
          : theme.palette.grey[800],
        marginLeft: theme.spacing(1),
      }}
    >
      {value}
    </label>
  )

  return (
    <Box
      hidden={showSelected && !isSelected}
    >
      <components.Option {...props}>
        {itemOption}
        {displayedKey && itemFieldOption}
        {count >= 0 ? (
          <FilterCountChecked isSelected={isSelected}>
            {count}
          </FilterCountChecked>
        ) : null}
      </components.Option>
    </Box>
  )
}
